import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { accFetchConnector, FetchAccAnalyticsPropsFromRedux } from '../accDataFetcher';
import { PNLAnalyticsEndpoint, PNLFetchStatus } from '../../actions/pnlAnalytics';
import { PNLGoodiesNonCompletedResponses } from '../../pnlAnalytics/PaperPlaceHolder';
import { AccountingDanaosVessels } from '../../pnlAnalytics/fetchTypes';
import ExpandableTable, { ExpandableTableConfig } from '../../tables/ExpandableTable';
import { UniqueTableName } from '../../common/uniqueTableName';
import { SimpleTableColumnConfig, TableSize } from '../../tables/types';
import { AggFuncName } from '../../common/cellRangeAgg';
import { exposuresNumFormatter } from '../../common/exposures';
import { makeStyles } from '@material-ui/core/styles';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducerStateType } from '../../reducers';
import { SetFiltersPayloadType } from '../../actions/accounting';
import { dollarVal2D, kFormatterWithParenthesis, redOnlyHundred } from '../../containers/pivotHelper';

const useStyles = makeStyles(() => ({
    groupCostColumn: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '80px !important',
        // fontSize: '15px !important',
    },
    balanceSheetColumn: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '300px !important',
        // fontSize: '15px !important',
    },
    cardColumn: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '300px !important',
        // fontSize: '15px !important',
    },
    totalColumn: {
        borderLeft: '#bfbfbf solid 1px',
    },
}));

type Props = FetchAccAnalyticsPropsFromRedux & RouteComponentProps & {};

const CashRecGroups = (props: Props) => {
    const classes = useStyles();
    const danaosVesselsData = props.pnlAnalytics.accounting_danaos_vessels;

    const filters = useSelector<RootReducerStateType, SetFiltersPayloadType>((state) => state.accounting, shallowEqual);

    if (danaosVesselsData.status !== PNLFetchStatus.COMPLETED) {
        return (
            <PNLGoodiesNonCompletedResponses
                endpoint={PNLAnalyticsEndpoint.AccountingDanaosVessels}
                data={danaosVesselsData}
                minHeight={'680px'}
            />
        );
    }

    // Construct the config columns
    let respData = danaosVesselsData.data! as AccountingDanaosVessels;

    let data = respData.cash_rec_groups;

    let columnsConfig: Array<SimpleTableColumnConfig> = [
        {
            name: 'company_fixed_name',
            title: 'Company',
            bodyTemplate2: (val, row) => {
                return row['company_code'] ? `[${row['company_code']}] ${val}` : val;
            },
            headerCellClassName: classes.groupCostColumn,
            bodyCellsClassName: classes.groupCostColumn,
        },
        {
            name: 'cash_rec_group',
            title: 'Cash Reconciliation Group',
            hoverElement: (row, _) => {
                let ledger_cards = row['ledger_card_code_all'];
                if (!ledger_cards) return '';
                return (
                    <div>
                        <p>{row['cash_rec_group']} includes the following ledger cards</p>
                        <p>{ledger_cards}</p>
                    </div>
                );
            },
            headerCellClassName: classes.balanceSheetColumn,
            bodyCellsClassName: classes.balanceSheetColumn,
        },
        {
            name: 'book_value',
            title: 'Amount',
            bodyTemplate: (val) => {
                return filters.showFractions ? dollarVal2D(val) : kFormatterWithParenthesis(val);
            },
            textColor: redOnlyHundred,
        },
    ];

    const config: ExpandableTableConfig = {
        uniqueTableName: UniqueTableName.CashRecGroups,
        title: 'Cash Reconciliation Groups',
        size: TableSize.Medium,
        columns: columnsConfig, // staticColumns.concat(compColumnsConfig),
        grandTotal: true,
        grandTotalRowName: 'Total',
        aggFormatVal: (aggFuncName: AggFuncName, val: number) => {
            return aggFuncName === AggFuncName.Count ? val : exposuresNumFormatter(val);
        },
        pivotDepth: 1,
        defaultExpandable: 0,
        stickyHeader: true,
    };

    return <ExpandableTable data={data} config={config} />;
};
export default accFetchConnector(CashRecGroups);
